/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Input, Label, Button, InputSelect, InputCheckbox, CustomLoading, Modal, Breadcrumb, SaveIcon, CustonModal } from "../../../../Components";

/* 🔗 SERVICE */
import { GroupServices } from "../../../../Services/equipamentosServices/group";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeLoationtypes, changeModal } from "../../../../Redux/Actions";

/* 📁 ASSETS*/
import { Excluir, Refazer, Desfazer } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer, ContainerOver, RowContainer } from "./styles";
import { MapOptions, ContainerMap, MapButtons, AreasOptions, AreasTitle, AreaSrcoll, BtnIcon } from "../../View/styles"

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const GroupView = () => {

    const { t } = useTranslation();

    document.title = t("administrative.sub-items.groups.view.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/equipamentos' },
        { text: 'equipments', page: '/adm/equipamentos' },
        { text: 'groups', page: '/adm/grupos' },
        { text: 'group', page: null }
    ]
    
    const navigate = useNavigate();
    let { id } = useParams();

    const mapContainerRef = useRef(null);
    const areaName = useRef();
    const Allareas = useRef([]);

    const Services = useRef(new GroupServices());
    
    const alocacao_typeField = useRef();
    const alocacaoField = useRef();
    const NameField = useRef();
    const StateField = useRef();
    const CityField = useRef();
    const LatField = useRef();
    const LongField = useRef();
    const Typefiled = useRef();
    
    const alocacaoValue = useRef();
    const NameValue = useRef();
    const CityValue = useRef();
    const LatValue = useRef();
    const LongValue = useRef();
    const TypeValue = useRef();
    
    const [areas, setAreas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [group, setGroup] = useState();
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedOption, setSelectedOption] = useState('location');
    const Allequipaments = useRef([]);
    const [equipamentsAdd, setEquipamentsAdd] = useState([]);
    const [activeModal, setActiveModal] = useState("");
    const is_active = useRef(false);
    
    const user = useSelector(state => state.userReducer);
    const Locations = useSelector(state => state.UserCurdReducer.Locations);
    const LocationTypes = useSelector(state => state.UserCurdReducer.LocationTypes);

    const EquipamentsType = [
        {
            id: "1f4d0674-1e7a-48c5-925f-87e2d99bcda5",
            name: 'Analisador'
        },
        {
            id: 'e2a17428-badd-4b2a-ace9-7f428f78cc1f',
            name: 'ETA',
        },
        {
            id: '782e9b76-5a92-4ad4-ba2a-5a6f84cb9ae1',
            name: 'Macro Medidor',
        },
        {
            id: '8831aa23-aa96-468f-bd48-10463cdaea6b',
            name: 'Reservatório'
        },
        {
            id: 'de4a6821-eb4c-492b-96c1-7ab704f053f6',
            name: 'Hidrômetro',
        },
        {
            id: 'ce27f1ab-2a42-45a2-a5c1-2a4e498b90d6',
            name: 'Sensor de nível'
        },
        {
            id: '52e63208-66ed-4a57-b41f-6f93b1b12f76',
            name: 'LORA'
        },
    ];

    useEffect(() => {
        // Busca alocações do usuário
        const getLocations = async() => {
            try {
                let AllLocations = await Services.current.getLocations();
                
                let Types = Object.keys(AllLocations).map(type => {
                    return{
                        id: type,
                        name: type
                    }
                })
                store.dispatch(changeLoationtypes(Types));
            } catch (error) {
                console.log(error)
            }
        }

        // busca os estados
        const getStates = async() => {
            try {
                let States = await Services.current.getStates();
                setStates(States);
            } catch (error) {
                console.log(error)
            }
        }

        const getAreas = async(id) => {
            try {
                await Services.current.getAreas(id);
                const totalareas = await Services.current.getAllAreas();
                if(totalareas){
                    Allareas.current = totalareas;
                    setAreas(totalareas);
                }
            } catch (error) {
                console.log(error)
            }
        }

        // pega todos os equipamentos
        const getAllequipaments = async(currentEquipaments) => {
            try {
                let equipaments = await Services.current.getAuthorizedEquipaments();
                equipaments = equipaments.map(item=> {
                    if(currentEquipaments.includes(item.id)){item.checked = true}
                    return item
                })
                equipaments.sort((a, b) => a.name.localeCompare(b.name))
                Allequipaments.current = equipaments;
                setEquipamentsAdd(equipaments)
            } catch (error) {
                console.log(error)
            }
        }
        
        // Busca dados do grupo
        const getGroup = async () => {
            setLoading(true);
            try {
                let currentGroup = await Services.current.getGroup(id);

                if (!currentGroup) return;
                await getLocations();
                setGroup(currentGroup);

                Services.current.startMap(
                    mapContainerRef.current,
                    currentGroup.coordinates.latitude,
                    currentGroup.coordinates.longitude,
                    currentGroup.id,
                    currentGroup.name,
                    currentGroup.type.id || currentGroup.id_icon_type
                );


                await getStates();
                await ChangeCities(currentGroup?.city?.code_uf);
                await getAreas(id);

                if (NameField.current && typeof NameField.current.getInputDOMNode === "function") {
                    NameField.current.getInputDOMNode().value = group.name;
                }
                is_active.current = currentGroup.is_active;

                await getAllequipaments(currentGroup.equipments);
                
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getGroup();
    }, [id]);

    useEffect(() => {
        if (!group) return;

        try {
            if (StateField.current) StateField.current.value = group?.city?.code_uf;
            if (CityField.current) CityField.current.value = group?.city?.code_ibge;

            if (group.allocation) {
                Services.current.ChangeLocationType(group.allocation.allocation_type?.name);
                if (alocacao_typeField.current)
                    alocacao_typeField.current.value = group.allocation.allocation_type?.name;
                if (alocacaoField.current)
                    alocacaoField.current.value = group.allocation.id;
            }
        } catch (error) {
            console.error(error);
        }
    }, [group]);

    // method-spoofing
    // Salva as edições do usuário
    const Save = async() => {
        if(isValidField(NameValue.current) && isValidField(CityValue.current) && isValidField(LatValue.current) && isValidField(LongValue.current)
            && isValidField(alocacaoValue.current)){
            let form = {};
                            
            if(NameValue.current){form = {...form, 'name': NameValue.current}}
            if(alocacaoValue.current){form = {...form, 'id_allocation': alocacaoValue.current}}
            if(CityValue.current){form = {...form, 'city_code': CityValue.current}}
            if(LatValue.current){form = {...form, 'latitude': LatValue.current}}
            if(LongValue.current){form = {...form, 'longitude': LongValue.current}}
            if(TypeValue.current){form = {...form, 'id_icon_type': TypeValue.current}}
            if(TypeValue.current === 'e2a17428-badd-4b2a-ace9-7f428f78cc1f'){form = {...form, 'eta': 1}}else{form = {...form, 'eta': 0}}
            form = {...form, 'is_active': is_active.current === true ? true : false};
            form = {...form, '_method': 'PATCH'}
            
            // form.append('_method', 'PATCH')
            Services.current.editGroup(group.id , form);
            store.dispatch(changeModal(''));
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const ChangeCities = async(state) => {
        try {
            let Cities = await Services.current.getCities(state);
            setCities(Cities);
        } catch (error) {
            
        }
    }

    // Filtra equipamentos
    const filterEquipaments = (equipamentName) => {
        let filter = Allequipaments.current.filter((equipament) => equipament.name.toLowerCase().includes(equipamentName.toLowerCase()));
        setEquipamentsAdd(filter);
    }

    const saveLocations = async() => {
        const response = await Services.current.saveLocations(id, areaName.current ? areaName.current : group?.name);
        setGroup(response);
    }

    return (
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <TitleContainer>
                    <Title>{group?.name}</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                    <>
                        <ContainerRow onSubmit={(e) => e.preventDefault()}>
                            <ContainerColumn>
                                <Label text={t("inputs.name.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='name' 
                                    name='name' 
                                    type="text" 
                                    placeholder={t("inputs.name.placeholder")}
                                    innerRef={NameField}
                                    value={group?.name}
                                    invalidMessage={t("inputs.name.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        setGroup({...group, 'name': text})
                                        NameValue.current = text
                                    }}> 
                                </Input>

                                <Label text={t("inputs.state.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'state'}
                                    id={'state'}
                                    placeholder={t("inputs.state.placeholder")}
                                    invalidMessage={t("inputs.state.invalid-message")}
                                    options={states}
                                    innerRef={StateField}
                                    value={group?.city?.code_uf}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setGroup({...group, city: { ...group.city, code_uf: value},
                                        });
                                        ChangeCities(value)}}>
                                </InputSelect>

                                <Label text={t("inputs.city.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'city'}
                                    id={'city'}
                                    placeholder={t("inputs.city.placeholder")}
                                    invalidMessage={t("inputs.city.invalid-message")}
                                    options={cities}
                                    innerRef={CityField}
                                    value={group?.city?.code_ibge}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setGroup({...group, 'city': {...group.city, 'code_ibge': value}})
                                        CityValue.current = value}}>
                                </InputSelect>
                            </ContainerColumn>
                            
                            <ContainerColumn>
                                <Label text={t("inputs.allocation-type.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'alocacao_type'}
                                    name={'alocacao_type'}
                                    id={'alocacao_type'}
                                    placeholder={t("inputs.allocation-type.placeholder")}
                                    invalidMessage={t("inputs.allocation-type.invalid-message")}
                                    options={LocationTypes}
                                    innerRef={alocacao_typeField}
                                    value={group?.allocation?.allocation_type?.name}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setGroup({...group, 'allocation': {...group.allocation, 'allocation_type': {name: value}}})
                                        Services.current.ChangeLocationType(value, alocacaoField.current)
                                        }}>
                                </InputSelect>

                                <Label text={t("inputs.allocation-local.label")} aling="flex-start"/>
                                <InputSelect
                                    key={'alocacao'}
                                    name={'alocacao'}
                                    id={'alocacao'}
                                    placeholder={t("inputs.allocation-local.placeholder")}
                                    invalidMessage={t("inputs.allocation-local.invalid-message")}
                                    options={Locations}
                                    innerRef={alocacaoField}
                                    value={group?.allocation?.id}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        setGroup({...group, 'allocation': {...group.allocation, 'id': value}})
                                        alocacaoValue.current = value}}>
                                </InputSelect>

                                <Label text={t("inputs.group-icon.label")} aling="flex-start"/>
                                <InputSelect
                                    name={'equipament'}
                                    id={'equipament'}
                                    placeholder={t("inputs.group-icon.placeholder")}   
                                    invalidMessage={t("inputs.group-icon.invalid-message")}
                                    options={EquipamentsType}
                                    value={group?.id_icon_type}
                                    innerRef={Typefiled}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => {
                                        TypeValue.current = value
                                    }}>
                                </InputSelect>
                            </ContainerColumn>

                            <ContainerColumn>
                                <Label text={t("inputs.latitude.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='latitude' 
                                    name='latitude' 
                                    type="text" 
                                    placeholder={t("inputs.latitude.placeholder")}
                                    value={group?.coordinates?.latitude}
                                    innerRef={LatField}
                                    invalidMessage={t("inputs.latitude.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        LatValue.current = text
                                        setGroup({...group, 'coordinates': {...group.coordinates, 'latitude': text}})
                                    }}> 
                                </Input>

                                <Label text={t("inputs.longitude.label")} aling="flex-start"/>
                                <Input 
                                    aling="flex-start"
                                    id='name' 
                                    name='name' 
                                    type="text" 
                                    placeholder={t("inputs.longitude.placeholder")}
                                    value={group?.coordinates?.longitude}
                                    innerRef={LongField}
                                    invalidMessage={t("inputs.longitude.invalid-message")}
                                    validationFunction={(text) => isValidField(text)}
                                    onchange={(text) => {
                                        LongValue.current = text
                                        setGroup({...group, 'coordinates': {...group.coordinates, 'longitude': text}})
                                    }}> 
                                </Input>

                                <InputCheckbox text={t("checkbox.is-active")} onChange={(value)=> {
                                        is_active.current = value;
                                        setGroup({...group, 'is_active': value });
                                    }} checked={group?.is_active}/>

                                <Label text={'\u00A0'} aling="flex-start"/>
                                <div className="group-actions">
                                    <Button text={t("buttons.equipments")} width={'150px'} onClick={() => store.dispatch(changeModal('addEquipaments'))}/>
                                    <Button text={t("buttons.setup-map")} width={'fit-content'} onClick={() => {
                                        store.dispatch(changeModal('groupLocation'));
                                        Services.current.resizeMap();    
                                    }}/>
                                </div>
                            </ContainerColumn>
                        </ContainerRow>



                        <ButtonsContainer>
                            {user?.user?.can?.includes('group.edit') ?
                                <>
                                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                                </>
                            :<></>}
                            {user?.user?.can?.includes('group.delete') ?
                                <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} 
                                    onClick={() => setActiveModal('delete-group')} 
                                icon={<ImageIcon src={Excluir}/>}/>
                            :<></>}
                        </ButtonsContainer>  
                    </>
                }
            </Container>

            <Modal title={'Adicionar equipamento ao grupo ' + group?.name} name={'addEquipaments'} width={'70%'} height={'90%'} > 
                    <Label text={t("inputs.equipment-name.label")} aling="flex-start"/>
                    <Input
                        aling="flex-start"
                        id='equipamentName'
                        name='equipamentName'
                        type="text"
                        placeholder={t("inputs.equipment-name.placeholder")}
                        invalidMessage={t("inputs.equipment-name.invalid-message")}
                        validationFunction={(text) => isValidField(text)}
                        onchange={(text) => filterEquipaments(text)}>
                    </Input>

                <ContainerOver onSubmit={(e) => e.preventDefault()}>
                    { 
                        equipamentsAdd.map((item, index) => (
                            <InputCheckbox key={index} id={item.id} name={item.id} text={item.name} checked={item.checked} 
                                onChange={async function(value){
                                    try {
                                        if(value){
                                            await Services.current.addEquipamentToGroup(group.id, item.id);
                                            item.checked = value;
                                            return true;
                                        }else{
                                            await Services.current.removeEquipamentFromGroup(group.id, item.id);
                                            item.checked = value;
                                            return true;
                                        }
                                    } catch (error) {
                                        toast('Erro ao adicionar equipamento', {
                                            position: "top-center",
                                            type: 'error',
                                            autoClose: 3000,
                                            hideProgressBar: false,
                                            closeOnClick: true,
                                            pauseOnHover: false,
                                            draggable: false,
                                            progress: undefined,
                                        });
                                        return false;
                                    }
                                }}/>
                        ))
                    }
                </ContainerOver>
                <Button text={t("buttons.ok")} width={'150px'} onClick={() => store.dispatch(changeModal(''))}/>
            </Modal>

            <Modal name={'groupLocation'} width={'70%'} height={'90%'}>
                <MapOptions>
                    <Button text={t("buttons.area")} width={'fit-content'}  color={selectedOption === 'area' ? 'gradienteGreen' : 'green'} onClick={() => {
                        setSelectedOption('area')
                        Services.current.setClickType('area');
                    }}/>

                    <Button text={t("buttons.group-location")} width={'fit-content'} color={selectedOption === 'location' ? 'gradienteGreen' : 'green'} onClick={() => {
                        setSelectedOption('location')
                        Services.current.setClickType('location');
                    }}/>
                </MapOptions>

                <div
                    style={{ 
                    position: 'relative',
                    height: '100%',
                    width: '100%'
                    }}>

                    <ContainerMap ref={mapContainerRef} />

                    <MapButtons $left={'5px'}>
                        <Button text={t("buttons.redo")} icon={<BtnIcon src={Refazer}/>} width={'fit-content'} onClick={() => {
                            Services.current.redo();
                        }}/>
                        <Button text={t("buttons.undo")} icon={<BtnIcon src={Desfazer}/>} width={'fit-content'} onClick={() => {
                            Services.current.undo();
                        }}/>
                    </MapButtons>

                    <MapButtons $right={'5px'}>
                        <Button text={t("buttons.cancel")} width={'150px'} onClick={() => store.dispatch(changeModal(''))}/>

                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => saveLocations()}/>
                    </MapButtons>

                    <AreasOptions $left={'5px'} $selectedOption={selectedOption === 'area'}>
                        <Label text={t("inputs.name.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='name' 
                            name='name' 
                            type="text" 
                            placeholder={t("inputs.name.placeholder")}
                            invalidMessage={t("inputs.name.invalid-message")}
                            validationFunction={(text) => isValidField(text)}
                            onchange={(text) => {
                                areaName.current = text;
                            }}> 
                        </Input>
                    </AreasOptions>

                    <AreasOptions $right={'5px'} $bottom={'95px'} $selectedOption={selectedOption === 'area'}>
                        <AreasTitle>{t("modal.equipment-location.areas")}</AreasTitle>
                        <AreaSrcoll>
                            {
                                areas.map((area, index) => (
                                    <InputCheckbox key={area.id} text={area.name} onChange={async (value)=> {
                                        if(value){
                                            const response = await Services.current.addArea(id, area.id);
                                            return response
                                        }else{
                                            const response = await Services.current.removeArea(id, area.id);
                                            return response
                                        }
                                    }} checked={area.checked}/>
                                ))
                            }
                        </AreaSrcoll>
                    </AreasOptions>
                </div>
            </Modal>
            <CustonModal Title={t("modal.delete-equipment-group.title")} Active={activeModal === 'delete-group'}>
                <RowContainer>
                    <Button width={'fit-content'} text={t("buttons.confirm")} onClick={() => Services.current.deleteGroup(id, navigate)}/>
                    <Button $borderRadius={'10px'} text={t("buttons.cancel")} color={'white-red'} onClick={() => setActiveModal('')}> {t("buttons.cancel")} </Button>
                </RowContainer>
            </CustonModal>
        </>
    );
}

export default GroupView;